import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { AssemblyWithChildren, JobStatusSchema, PartTypeSchema } from "shared";

export const areAllChildrenPredicted = (children: AssemblyWithChildren<QuoteRequestLineDto>[]) => {
  return children.every(
    (child) =>
      child.quoteRequestLine.predictionStatus === JobStatusSchema.enum.PROCESSED ||
      child.quoteRequestLine.part.type === PartTypeSchema.enum.CONSUMABLE,
  );
};
